// AG _ Moved here from akFeautreSelection -
// We need special UX for level, so I remove duplicated entries with
// different levels -
// THis should actually be done on the server and be part of the API
import {FeatureWithName} from "./useFeatureSuggestions";
import {getQualifierByRelation} from "fe-common/logic";
import {Relations} from "shared";

export function groupQualifiedWithLevel(suggestions: FeatureWithName[]) {
    const seen = new Set<string>();
    const results = [];
    for (let s of suggestions) {
        if (
            !s?.value?.qualifiers?.length ||
            !getQualifierByRelation(s?.value, Relations.LEVEL)
        ) {
            results.push(s);
        } else {
            if (!seen.has(s?.value?.feature?.id)) {
                results.push(s);
                seen.add(s.value.feature.id);
            }
        }
    }
    return results;
}